import axios from "axios";
import axios2 from "@/axios";

const state = {
  cncOnly: "0",
  guest: false,
  anon: false,
  user: null,
};

const getters = {
  retrieveUser: (state) => {
    return state.user;
  },

  retrieveGuest: (state) => {
    return state.guest;
  },

  retrieveAnon: (state) => {
    return state.anon;
  },
};

const actions = {
  async authUser({ commit }, payload) {
    console.log(" -- Auth User Params");
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("auth-user", params);
    if (response.data.success == true) {
      commit("setUser", response.data);
    }
    return response.data;
  },

  async authAnonUser({ commit }, payload) {
    console.log(" -- Auth Anon User Params");
    console.log(payload);

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("auth-anon-user", params);
    if (response.data.success == true) {
      commit("setUser", response.data);
    }
    return response.data;
  },

  setGuestUser: (context, payload) => {
    context.commit("setGuest", payload);
  },

  setAnonUser: (context, payload) => {
    context.commit("setAnon", payload);
  },

  async checkDeliveryPostcode(context, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    let response = await axios.post("validate-postcode", params);

    if (response) {
      console.log("-- Returning Response");
      if (response.data.success) {
        context.commit("setCncFlag", response.data.cncOnly);
      }

      return response.data;
    }

    return false;
  },

  async updateAnonUserPostcodeAction(context, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    let response = await axios.post("update-anon-user-postcode", params);

    if (response) {
      console.log("-- Returning Response");
      return response.data;
    }

    return false;
  },

  passwordResetAction(context, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    return new Promise((resolve, reject) => {
      axios
        .post("gen-new-password", params)
        .then((response) => {
          if (response.data.success == true) {
            resolve("reset-success");
          } else {
            reject(response.data.message);
          }
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  registerNewCashUser({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    return new Promise((resolve, reject) => {
      axios
        .post("create-new-cash-user", params)
        .then((response) => {
          if (response.data.success == true) {
            resolve("registration-complete");
          } else {
            reject(response.data.message);
          }
        })
        .catch((e) => {
          reject(e);
        });
    });
  },

  async registerBusinessAction(context,payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios2.post("general/register-business", params);
    return response.data;  
  },

  async updateUserDetails({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("update-user-details", params);
    if (response.data.success == true) {
      commit("setUser", response.data);
    }
    return response.data;
  },
  async updatePassword({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("set-new-password", params);
    return response.data;
  },

  async deleteUserAccount({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("delete-user", params);
    return response.data;
  },

  async requestCopyStatement({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("request-copy-statement", params);
    return response.data;
  },
  async requestCopyInvoice({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("request-copy-invoice", params);
    return response.data;
  },
  async fetchAllergenReport({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("get-product-allergens-report", params);
    return response.data;
  },
  async sendAllergenReportCsv({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post(
      "get-product-allergens-report-csv",
      params
    );
    return response.data;
  },

  async fetchNutritionReport({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("get-product-nutrition-report", params);
    return response.data;
  },
  async sendNutritionReportCsv({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post(
      "get-product-nutrition-report-csv",
      params
    );
    return response.data;
  },
  async fetchProductAllergens({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("get-product-allergens", params);
    return response.data;
  },
  async fetchProductNutritions({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("get-product-nutrition", params);
    return response.data;
  },
  async fetchProductSpecsheet({commit},payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("get-product-specsheet", params);
    return response.data;
  },
  async fetchProductSales({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("get-prod-stats", params);
    return response.data;
  },

  async sendPostcodeRequest({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("request-postcode", params);
    return response.data;
  },
  clearUser({ commit }) {
    commit("setUser", null);
    commit("setCncFlag", null);
  },
};

const mutations = {
  //setUser: (state, user) => Object.assign(state, user),
  setUser: (state, user) => (state.user = user),
  setGuest: (state, user) => (state.guest = user),
  setAnon: (state, user) => (state.anon = user),
  setCncFlag: (state, flag) => (state.cncOnly = flag),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
